import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { IEditUserProfileCommand, IUserViewModel } from '@services/cleanfill-api/cleanfill-api.generated';
import { StoreSignupService } from '@services/cleanfill-core/registration/store-signup.service';
import { StoreUsersService } from '@services/cleanfill-core/store-users/store-users.service';
import { AuthService } from '@services/core/auth.service';
import { ConfirmDialogResult, ConfirmDialogType } from '@widgets/site-common/confirm-dialog/confirm-dialog.model';
import { ConfirmDialogService } from '@widgets/site-common/confirm-dialog/confirm-dialog.service';

interface IFormGroupValue {
  fullName: string;
  email: string;
  phone: string;
  jobPosition: string;
}

@Component({
  selector: 'accept-invite',
  templateUrl: './accept-invite.component.html',
  styleUrls: ['./accept-invite.component.scss']
})
export class AcceptInviteComponent implements OnInit {
  @ViewChild('successMessage') successMessage: TemplateRef<HTMLDivElement>;

  dialogRef: MatDialogRef<HTMLDivElement>;
  user: IEditUserProfileCommand;
  form: FormGroup;
  success = false;

  constructor(
    private fb: FormBuilder,
    private userStore: StoreUsersService,
    private dialog: MatDialog,
    private signUpService: StoreSignupService,
    private confirmDialogService: ConfirmDialogService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private msalService: MsalService
  ) {
    this.initForm();
  }

  ngOnInit() {
    this.initDataSources();

    this.authService.loadPermissions().then(t => {
      if (t?.uniqueId != null) {
        if (t?.legalEntityUniqueId === null) {
          const keys = Object.keys(this.route.snapshot.queryParams);
          if (keys.length > 0) {
            this.signUpService.inviteUser(keys[0]).then(x => {
              this.confirmDialogService.confirm('Invite successful!', '', ConfirmDialogType.Ok).then(y => {
                if (y === ConfirmDialogResult.Ok) {
                  this.authService.loadPermissions();
                  this.router.navigate(['/']);
                }
              });
            });
          }
        } else {
          this.confirmDialogService
            .confirm(
              `You are currently logged in. You will now be logged out from this company. Please try the invite link again.`,
              '',
              ConfirmDialogType.Ok
            )
            .then(result => {
              if (result === ConfirmDialogResult.Ok) {
                this.msalService.logout();
                // this.router.navigate(['/']);
                return;
              }
            });
        }
      }
    });
  }

  initDataSources() {
    this.authService.activeUser$.subscribe(t => {
      const account = this.msalService.getAccount();
      this.patchValue({
        fullName: `${this.authService.activeUser.firstName} ${this.authService.activeUser.lastName}`,
        emailAddress: account?.idTokenClaims.emails?.length > 0 ? account?.idTokenClaims?.emails[0] : '',
        phoneNumber: ``,
        jobTitle: ``
      });
    });
  }

  initForm(): void {
    this.form = this.fb.group({
      fullName: ['', Validators.required],
      email: ['', Validators.required],
      phone: ['', Validators.required],
      jobPosition: ['', Validators.required]
    });
  }

  async patchValue(user: IUserViewModel): Promise<void> {
    this.form.patchValue({
      fullName: user.fullName,
      email: user.emailAddress,
      phone: user.phoneNumber,
      jobPosition: user.jobTitle
    });
  }
}
